import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroupAnnualEnrollmentStatus, getGroupLifeContractList, getProductSummary } from '../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { setGroupLifeContractList, setProductSummary } from './document-download-slice';
import { setGroupAnnualEnrollmentStatus } from '../groups/groups-slice';


export function useDocumentDownloadState() {
	const dispatch = useDispatch();
	const groupId = useSelector<TcsmStates, number>(state => state.groupsState?.currentGroup?.group_id);
	const loaded = useSelector<TcsmStates, boolean>(state => state.documentDownload?.documentsLoaded && state.documentDownload?.groupLifeContractListLoaded );

	useEffect(() => {
		if (groupId) {
			dispatch(getProductSummary(groupId, (data) => dispatch(setProductSummary(data))));
			dispatch(getGroupLifeContractList(groupId, (data) => dispatch(setGroupLifeContractList(data))));
      dispatch(getGroupAnnualEnrollmentStatus(groupId, (data) => dispatch(setGroupAnnualEnrollmentStatus(data.data.group_ae_status))));
    }
	}, [groupId]);

	return loaded;
}
